import PropTypes from 'prop-types';
import SceneToggleButton from './SceneToggleButton';

function LaserToggle({
    toggle,
}) {
    return (
        <SceneToggleButton
            ariaLabel={toggle.ariaLabel}
            ariaPressed={toggle.ariaPressed}
            className={`scene-toggle laser-pointer ${toggle.active ? 'active' : ''}`}
            disabled={toggle.disabled}
            onClick={toggle.onClick}
            title={toggle.title}
        >
            <>
                <span className="scene-toggle-icon-shell">
                    <i className="material-icons icon" role="presentation">flare</i>
                </span>
                <span>Laser Pointer</span>
            </>
        </SceneToggleButton>
    );
}

LaserToggle.propTypes = {
    toggle: PropTypes.shape({
        active: PropTypes.bool.isRequired,
        ariaLabel: PropTypes.string.isRequired,
        ariaPressed: PropTypes.bool.isRequired,
        disabled: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default LaserToggle;
